import React, { useState } from "react";

function ExpandableItem({
    title,
    actions,
    card,
    children,
    defaultExpanded = false,
    indent = "16px",
    headerTitleStyle,
    headerStyle
}) {
    const [expanded, setExpanded] = useState(defaultExpanded);

    let headerContainerStyle = {
        cursor: "pointer",
        fontWeight: "bold",
        border: "1px solid #ccc",
        padding: "4px 8px",
        borderRadius: "4px",
        backgroundColor: "#f7f7f7",
        display: "flex",
        alignItems: "center"
    };

    if (headerStyle) {
        headerContainerStyle = { ...headerContainerStyle, ...headerStyle };
    }

    return (
        <div style={{ marginLeft: "20px", marginBottom: "8px" }}>
            <div onClick={function () { setExpanded(!expanded); }} style={headerContainerStyle}>
                <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
                    <span style={{ color: "black" }}>
                        {expanded ? "▼" : "▶"}
                    </span>
                    <span style={{ marginLeft: "8px", ...headerTitleStyle }}>
                        {title}
                    </span>
                </div>
                {actions && (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {actions}
                    </div>
                )}
            </div>
            {expanded && (
                <>
                    {card && (
                        <div style={{ marginTop: "4px" }}>
                            {card}
                        </div>
                    )}
                    {children && (
                        <div style={{ marginTop: "4px", marginLeft: indent }}>
                            {children}
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default ExpandableItem;